import { useQuery } from "@tanstack/react-query";
import { fetchUserHomePageAppointments } from "../../../enums/queryFunction/Fetch";
import { APPOINTMENTS_USER_HOMEPAGE } from "../../../enums/QueryKeys";

export default function useGetHomePageUserAppointments(userId) {
  const { data, isLoading, error } = useQuery({
    queryKey: [APPOINTMENTS_USER_HOMEPAGE, userId],
    queryFn: () => fetchUserHomePageAppointments(),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, error };
}